/* eslint-enable */

class FeaturedContentHeaderImageText {

	constructor(args = { sectionsContainer: document }) {
		this.sectionsContainer = args.sectionsContainer;
		this.$module3 = this.sectionsContainer.querySelectorAll('.featured-content-header-image-text');
		
		if (!this.$module3.length)
			return;
		
		this.$module3Elements = [];
		
		this.$module3.forEach(module => {
			this.$module3Elements.push(module.querySelectorAll('.anima'));
		});

		this.init();
	}

	/* eslint-disable class-methods-use-this, no-unused-vars */
	init() {
		this.setAnimation();
	}

	setAnimation() {
		this.$module3.forEach((module, index) => {
			gsap.set(module, { opacity: 0.0001 });
			gsap.set(this.$module3Elements[index], { yPercent: 20, opacity: 0.0001, onComplete: () => {
				this.initAnimate(index);
			} });
		});
	}

	initAnimate(index) {
		this.animateModule3 = gsap.timeline({
			defaults: { duration: 1.2, ease: 'power4.out' },
            scrollTrigger: {
                trigger: this.$module3[index],
				start: '-20% 50%'
			},
			onComplete: () => {
				gsap.set(this.$module3Elements[index], { clearProps: true });
			}
        });
    
        this.animateModule3.addLabel('step1');
        this.animateModule3.to(this.$module3[index], { opacity: 1, duration: 1 }, 'step1');
		this.animateModule3.to(this.$module3Elements[index], { yPercent: 0, opacity: 1, stagger: 0.2 }, 'step1+=0.3');
	}
	/* eslint-enable class-methods-use-this, no-unused-vars */
}

export default FeaturedContentHeaderImageText;
